
<template>
  <div>
    <div class="wrap">
      <!--      {{getStatusRequestFilter}}-->
      <!--      <button v-on:click="valueAxis.zoomToValues( valueAxis.min, valueAxis.max)">zoom</button>-->
      <!--    <button v-on:click="clearChart">DELETE-Leni</button>-->
      <!--    <button v-on:click="setDataChart">SetData</button>-->
      <!--    <button v-on:click="addSeries">AddSeries</button>-->
      <div class="line-active">
        <div class="text-gray fz13" v-for="(d, i) in getDataFilter.nameLines" :key="i"> <div :style="'background-color:' + stroke[i]"></div> {{ d}}</div>
        <div v-if="average" class="text-average-in-queue fz13 text-gray">Average for the selected period: <span class="fz13 text-dark fw500"> {{getAverageInQueue()}}</span></div>
      </div>
      <!--{{arraySeriesAdding.length}}-->
      <!--    {{arraySeries.length}}-->
      <div class="chart" id="chartdiv"></div>
      <div class="bg-w"></div>
      <section class="no-data" v-if="noData">
        <!--      <p class="fz20 text-gray">No data for the specified period</p>-->
        <svg width="320" height="214" viewBox="0 0 320 214" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path class="no-data-text" d="M88.75 191H87V181.234H83.5469V179.727H92.1953V181.234H88.75V191ZM93.4844 191V179.727H95.1562V184.156H95.1953C95.4245 183.672 95.7604 183.299 96.2031 183.039C96.6458 182.773 97.1771 182.641 97.7969 182.641C98.6927 182.641 99.3958 182.917 99.9062 183.469C100.422 184.021 100.68 184.766 100.68 185.703V191H98.9844V186.031C98.9844 185.417 98.8307 184.94 98.5234 184.602C98.2214 184.263 97.776 184.094 97.1875 184.094C96.5677 184.094 96.0755 184.292 95.7109 184.688C95.3516 185.078 95.1719 185.599 95.1719 186.25V191H93.4844ZM107.18 184.586C106.81 184.19 106.333 183.992 105.75 183.992C105.167 183.992 104.682 184.193 104.297 184.594C103.911 184.99 103.698 185.503 103.656 186.133H107.766C107.745 185.497 107.549 184.982 107.18 184.586ZM107.758 188.586H109.359C109.24 189.341 108.854 189.958 108.203 190.438C107.552 190.917 106.758 191.156 105.82 191.156C104.617 191.156 103.669 190.779 102.977 190.023C102.289 189.263 101.945 188.232 101.945 186.93C101.945 185.638 102.289 184.599 102.977 183.812C103.669 183.026 104.594 182.633 105.75 182.633C106.885 182.633 107.786 183.005 108.453 183.75C109.12 184.49 109.453 185.484 109.453 186.734V187.312H103.648V187.414C103.648 188.133 103.849 188.708 104.25 189.141C104.651 189.573 105.188 189.789 105.859 189.789C106.333 189.789 106.74 189.68 107.078 189.461C107.417 189.242 107.643 188.951 107.758 188.586ZM110.766 191V182.781H112.375V184.18H112.414C112.549 183.701 112.792 183.326 113.141 183.055C113.49 182.784 113.906 182.648 114.391 182.648C114.552 182.648 114.745 182.669 114.969 182.711V184.281C114.818 184.219 114.565 184.188 114.211 184.188C113.669 184.188 113.24 184.357 112.922 184.695C112.609 185.034 112.453 185.495 112.453 186.078V191H110.766ZM120.523 184.586C120.154 184.19 119.677 183.992 119.094 183.992C118.51 183.992 118.026 184.193 117.641 184.594C117.255 184.99 117.042 185.503 117 186.133H121.109C121.089 185.497 120.893 184.982 120.523 184.586ZM121.102 188.586H122.703C122.583 189.341 122.198 189.958 121.547 190.438C120.896 190.917 120.102 191.156 119.164 191.156C117.961 191.156 117.013 190.779 116.32 190.023C115.633 189.263 115.289 188.232 115.289 186.93C115.289 185.638 115.633 184.599 116.32 183.812C117.013 183.026 117.938 182.633 119.094 182.633C120.229 182.633 121.13 183.005 121.797 183.75C122.464 184.49 122.797 185.484 122.797 186.734V187.312H116.992V187.414C116.992 188.133 117.193 188.708 117.594 189.141C117.995 189.573 118.531 189.789 119.203 189.789C119.677 189.789 120.083 189.68 120.422 189.461C120.76 189.242 120.987 188.951 121.102 188.586ZM127.414 191V182.781H129.102V191H127.414ZM128.953 181.297C128.76 181.484 128.529 181.578 128.258 181.578C127.987 181.578 127.755 181.484 127.562 181.297C127.375 181.109 127.281 180.883 127.281 180.617C127.281 180.346 127.375 180.117 127.562 179.93C127.755 179.742 127.987 179.648 128.258 179.648C128.534 179.648 128.766 179.742 128.953 179.93C129.146 180.117 129.242 180.346 129.242 180.617C129.242 180.883 129.146 181.109 128.953 181.297ZM130.68 185.109C130.68 184.375 130.977 183.779 131.57 183.32C132.164 182.862 132.94 182.633 133.898 182.633C134.81 182.633 135.557 182.865 136.141 183.328C136.729 183.786 137.036 184.383 137.062 185.117H135.477C135.435 184.742 135.271 184.448 134.984 184.234C134.698 184.021 134.32 183.914 133.852 183.914C133.393 183.914 133.023 184.016 132.742 184.219C132.466 184.422 132.328 184.685 132.328 185.008C132.328 185.508 132.747 185.862 133.586 186.07L134.969 186.391C135.797 186.589 136.383 186.859 136.727 187.203C137.076 187.542 137.25 188.016 137.25 188.625C137.25 189.375 136.932 189.984 136.297 190.453C135.667 190.922 134.846 191.156 133.836 191.156C132.872 191.156 132.086 190.927 131.477 190.469C130.872 190.01 130.536 189.401 130.469 188.641H132.141C132.208 189.036 132.393 189.341 132.695 189.555C132.997 189.763 133.404 189.867 133.914 189.867C134.419 189.867 134.818 189.771 135.109 189.578C135.406 189.38 135.555 189.115 135.555 188.781C135.555 188.516 135.466 188.305 135.289 188.148C135.112 187.992 134.81 187.859 134.383 187.75L132.914 187.391C131.424 187.031 130.68 186.271 130.68 185.109ZM141.812 191V182.781H143.422V184.156H143.461C143.69 183.677 144.023 183.305 144.461 183.039C144.898 182.773 145.427 182.641 146.047 182.641C146.948 182.641 147.648 182.911 148.148 183.453C148.648 183.99 148.898 184.732 148.898 185.68V191H147.203V186.008C147.203 185.383 147.055 184.909 146.758 184.586C146.466 184.258 146.031 184.094 145.453 184.094C144.859 184.094 144.385 184.286 144.031 184.672C143.677 185.057 143.5 185.57 143.5 186.211V191H141.812ZM156.898 190.016C156.19 190.776 155.245 191.156 154.062 191.156C152.88 191.156 151.935 190.776 151.227 190.016C150.518 189.25 150.164 188.208 150.164 186.891C150.164 185.578 150.518 184.542 151.227 183.781C151.935 183.016 152.88 182.633 154.062 182.633C155.245 182.633 156.19 183.016 156.898 183.781C157.607 184.542 157.961 185.578 157.961 186.891C157.961 188.208 157.607 189.25 156.898 190.016ZM154.062 189.766C154.734 189.766 155.266 189.513 155.656 189.008C156.047 188.503 156.242 187.797 156.242 186.891C156.242 185.99 156.044 185.286 155.648 184.781C155.258 184.276 154.729 184.023 154.062 184.023C153.396 184.023 152.865 184.276 152.469 184.781C152.078 185.286 151.883 185.99 151.883 186.891C151.883 187.797 152.078 188.503 152.469 189.008C152.865 189.513 153.396 189.766 154.062 189.766ZM165.602 191.141C164.56 191.141 163.724 190.755 163.094 189.984C162.464 189.214 162.148 188.182 162.148 186.891C162.148 185.599 162.461 184.57 163.086 183.805C163.716 183.034 164.549 182.648 165.586 182.648C166.164 182.648 166.68 182.784 167.133 183.055C167.586 183.32 167.93 183.685 168.164 184.148H168.195V179.727H169.891V191H168.25V189.602H168.219C167.974 190.081 167.622 190.458 167.164 190.734C166.711 191.005 166.19 191.141 165.602 191.141ZM166.047 184.07C165.38 184.07 164.852 184.326 164.461 184.836C164.07 185.341 163.875 186.026 163.875 186.891C163.875 187.76 164.07 188.448 164.461 188.953C164.852 189.458 165.38 189.711 166.047 189.711C166.698 189.711 167.221 189.456 167.617 188.945C168.013 188.43 168.211 187.745 168.211 186.891C168.211 186.042 168.013 185.359 167.617 184.844C167.221 184.328 166.698 184.07 166.047 184.07ZM174.5 189.805C175.094 189.805 175.591 189.625 175.992 189.266C176.398 188.901 176.602 188.453 176.602 187.922V187.273L174.578 187.398C174.073 187.435 173.682 187.56 173.406 187.773C173.135 187.982 173 188.263 173 188.617C173 188.977 173.135 189.266 173.406 189.484C173.682 189.698 174.047 189.805 174.5 189.805ZM174.031 191.141C173.224 191.141 172.565 190.911 172.055 190.453C171.549 189.995 171.297 189.398 171.297 188.664C171.297 187.945 171.562 187.375 172.094 186.953C172.625 186.526 173.378 186.286 174.352 186.234L176.602 186.102V185.469C176.602 185.01 176.456 184.654 176.164 184.398C175.872 184.138 175.469 184.008 174.953 184.008C174.474 184.008 174.083 184.115 173.781 184.328C173.484 184.542 173.297 184.836 173.219 185.211H171.625C171.672 184.451 172 183.831 172.609 183.352C173.219 182.872 174.021 182.633 175.016 182.633C176.01 182.633 176.802 182.878 177.391 183.367C177.984 183.857 178.281 184.513 178.281 185.336V191H176.664V189.648H176.625C176.391 190.102 176.034 190.464 175.555 190.734C175.081 191.005 174.573 191.141 174.031 191.141ZM180.414 180.836H182.109V182.781H183.672V184.117H182.109V188.648C182.109 189.003 182.19 189.263 182.352 189.43C182.513 189.596 182.766 189.68 183.109 189.68C183.359 189.68 183.544 189.667 183.664 189.641V190.977C183.456 191.029 183.143 191.055 182.727 191.055C181.898 191.055 181.305 190.885 180.945 190.547C180.591 190.203 180.414 189.633 180.414 188.836V184.117H179.219V182.781H180.414V180.836ZM187.812 189.805C188.406 189.805 188.904 189.625 189.305 189.266C189.711 188.901 189.914 188.453 189.914 187.922V187.273L187.891 187.398C187.385 187.435 186.995 187.56 186.719 187.773C186.448 187.982 186.312 188.263 186.312 188.617C186.312 188.977 186.448 189.266 186.719 189.484C186.995 189.698 187.359 189.805 187.812 189.805ZM187.344 191.141C186.536 191.141 185.878 190.911 185.367 190.453C184.862 189.995 184.609 189.398 184.609 188.664C184.609 187.945 184.875 187.375 185.406 186.953C185.938 186.526 186.69 186.286 187.664 186.234L189.914 186.102V185.469C189.914 185.01 189.768 184.654 189.477 184.398C189.185 184.138 188.781 184.008 188.266 184.008C187.786 184.008 187.396 184.115 187.094 184.328C186.797 184.542 186.609 184.836 186.531 185.211H184.938C184.984 184.451 185.312 183.831 185.922 183.352C186.531 182.872 187.333 182.633 188.328 182.633C189.323 182.633 190.115 182.878 190.703 183.367C191.297 183.857 191.594 184.513 191.594 185.336V191H189.977V189.648H189.938C189.703 190.102 189.346 190.464 188.867 190.734C188.393 191.005 187.885 191.141 187.344 191.141ZM202.852 190.016C202.143 190.776 201.198 191.156 200.016 191.156C198.833 191.156 197.888 190.776 197.18 190.016C196.471 189.25 196.117 188.208 196.117 186.891C196.117 185.578 196.471 184.542 197.18 183.781C197.888 183.016 198.833 182.633 200.016 182.633C201.198 182.633 202.143 183.016 202.852 183.781C203.56 184.542 203.914 185.578 203.914 186.891C203.914 188.208 203.56 189.25 202.852 190.016ZM200.016 189.766C200.688 189.766 201.219 189.513 201.609 189.008C202 188.503 202.195 187.797 202.195 186.891C202.195 185.99 201.997 185.286 201.602 184.781C201.211 184.276 200.682 184.023 200.016 184.023C199.349 184.023 198.818 184.276 198.422 184.781C198.031 185.286 197.836 185.99 197.836 186.891C197.836 187.797 198.031 188.503 198.422 189.008C198.818 189.513 199.349 189.766 200.016 189.766ZM205.219 191V182.781H206.828V184.156H206.867C207.096 183.677 207.43 183.305 207.867 183.039C208.305 182.773 208.833 182.641 209.453 182.641C210.354 182.641 211.055 182.911 211.555 183.453C212.055 183.99 212.305 184.732 212.305 185.68V191H210.609V186.008C210.609 185.383 210.461 184.909 210.164 184.586C209.872 184.258 209.438 184.094 208.859 184.094C208.266 184.094 207.792 184.286 207.438 184.672C207.083 185.057 206.906 185.57 206.906 186.211V191H205.219ZM217.68 180.836H219.375V182.781H220.938V184.117H219.375V188.648C219.375 189.003 219.456 189.263 219.617 189.43C219.779 189.596 220.031 189.68 220.375 189.68C220.625 189.68 220.81 189.667 220.93 189.641V190.977C220.721 191.029 220.409 191.055 219.992 191.055C219.164 191.055 218.57 190.885 218.211 190.547C217.857 190.203 217.68 189.633 217.68 188.836V184.117H216.484V182.781H217.68V180.836ZM222.391 191V179.727H224.062V184.156H224.102C224.331 183.672 224.667 183.299 225.109 183.039C225.552 182.773 226.083 182.641 226.703 182.641C227.599 182.641 228.302 182.917 228.812 183.469C229.328 184.021 229.586 184.766 229.586 185.703V191H227.891V186.031C227.891 185.417 227.737 184.94 227.43 184.602C227.128 184.263 226.682 184.094 226.094 184.094C225.474 184.094 224.982 184.292 224.617 184.688C224.258 185.078 224.078 185.599 224.078 186.25V191H222.391ZM236.086 184.586C235.716 184.19 235.24 183.992 234.656 183.992C234.073 183.992 233.589 184.193 233.203 184.594C232.818 184.99 232.604 185.503 232.562 186.133H236.672C236.651 185.497 236.456 184.982 236.086 184.586ZM236.664 188.586H238.266C238.146 189.341 237.76 189.958 237.109 190.438C236.458 190.917 235.664 191.156 234.727 191.156C233.523 191.156 232.576 190.779 231.883 190.023C231.195 189.263 230.852 188.232 230.852 186.93C230.852 185.638 231.195 184.599 231.883 183.812C232.576 183.026 233.5 182.633 234.656 182.633C235.792 182.633 236.693 183.005 237.359 183.75C238.026 184.49 238.359 185.484 238.359 186.734V187.312H232.555V187.414C232.555 188.133 232.755 188.708 233.156 189.141C233.557 189.573 234.094 189.789 234.766 189.789C235.24 189.789 235.646 189.68 235.984 189.461C236.323 189.242 236.549 188.951 236.664 188.586ZM82.5391 210V201.781H84.2266V210H82.5391ZM84.0781 200.297C83.8854 200.484 83.6536 200.578 83.3828 200.578C83.112 200.578 82.8802 200.484 82.6875 200.297C82.5 200.109 82.4062 199.883 82.4062 199.617C82.4062 199.346 82.5 199.117 82.6875 198.93C82.8802 198.742 83.112 198.648 83.3828 198.648C83.6589 198.648 83.8906 198.742 84.0781 198.93C84.2708 199.117 84.3672 199.346 84.3672 199.617C84.3672 199.883 84.2708 200.109 84.0781 200.297ZM85.9531 210V201.781H87.5625V203.156H87.6016C87.8307 202.677 88.1641 202.305 88.6016 202.039C89.0391 201.773 89.5677 201.641 90.1875 201.641C91.0885 201.641 91.7891 201.911 92.2891 202.453C92.7891 202.99 93.0391 203.732 93.0391 204.68V210H91.3438V205.008C91.3438 204.383 91.1953 203.909 90.8984 203.586C90.6068 203.258 90.1719 203.094 89.5938 203.094C89 203.094 88.526 203.286 88.1719 203.672C87.8177 204.057 87.6406 204.57 87.6406 205.211V210H85.9531ZM97.7578 210.141C96.7161 210.141 95.8802 209.755 95.25 208.984C94.6198 208.214 94.3047 207.182 94.3047 205.891C94.3047 204.599 94.6172 203.57 95.2422 202.805C95.8724 202.034 96.7057 201.648 97.7422 201.648C98.3203 201.648 98.8359 201.784 99.2891 202.055C99.7422 202.32 100.086 202.685 100.32 203.148H100.352V198.727H102.047V210H100.406V208.602H100.375C100.13 209.081 99.7786 209.458 99.3203 209.734C98.8672 210.005 98.3464 210.141 97.7578 210.141ZM98.2031 203.07C97.5365 203.07 97.0078 203.326 96.6172 203.836C96.2266 204.341 96.0312 205.026 96.0312 205.891C96.0312 206.76 96.2266 207.448 96.6172 207.953C97.0078 208.458 97.5365 208.711 98.2031 208.711C98.8542 208.711 99.3776 208.456 99.7734 207.945C100.169 207.43 100.367 206.745 100.367 205.891C100.367 205.042 100.169 204.359 99.7734 203.844C99.3776 203.328 98.8542 203.07 98.2031 203.07ZM103.836 210V201.781H105.523V210H103.836ZM105.375 200.297C105.182 200.484 104.951 200.578 104.68 200.578C104.409 200.578 104.177 200.484 103.984 200.297C103.797 200.109 103.703 199.883 103.703 199.617C103.703 199.346 103.797 199.117 103.984 198.93C104.177 198.742 104.409 198.648 104.68 198.648C104.956 198.648 105.188 198.742 105.375 198.93C105.568 199.117 105.664 199.346 105.664 199.617C105.664 199.883 105.568 200.109 105.375 200.297ZM114.305 204.609H112.695C112.607 204.146 112.393 203.768 112.055 203.477C111.721 203.185 111.292 203.039 110.766 203.039C110.109 203.039 109.583 203.297 109.188 203.812C108.797 204.323 108.602 205.016 108.602 205.891C108.602 206.781 108.797 207.479 109.188 207.984C109.583 208.49 110.115 208.742 110.781 208.742C111.297 208.742 111.719 208.609 112.047 208.344C112.38 208.073 112.596 207.698 112.695 207.219H114.32C114.232 208.099 113.862 208.81 113.211 209.352C112.565 209.888 111.75 210.156 110.766 210.156C109.583 210.156 108.641 209.776 107.938 209.016C107.234 208.25 106.883 207.208 106.883 205.891C106.883 204.589 107.234 203.555 107.938 202.789C108.641 202.018 109.578 201.633 110.75 201.633C111.771 201.633 112.599 201.919 113.234 202.492C113.87 203.06 114.227 203.766 114.305 204.609ZM118.391 208.805C118.984 208.805 119.482 208.625 119.883 208.266C120.289 207.901 120.492 207.453 120.492 206.922V206.273L118.469 206.398C117.964 206.435 117.573 206.56 117.297 206.773C117.026 206.982 116.891 207.263 116.891 207.617C116.891 207.977 117.026 208.266 117.297 208.484C117.573 208.698 117.938 208.805 118.391 208.805ZM117.922 210.141C117.115 210.141 116.456 209.911 115.945 209.453C115.44 208.995 115.188 208.398 115.188 207.664C115.188 206.945 115.453 206.375 115.984 205.953C116.516 205.526 117.268 205.286 118.242 205.234L120.492 205.102V204.469C120.492 204.01 120.346 203.654 120.055 203.398C119.763 203.138 119.359 203.008 118.844 203.008C118.365 203.008 117.974 203.115 117.672 203.328C117.375 203.542 117.188 203.836 117.109 204.211H115.516C115.562 203.451 115.891 202.831 116.5 202.352C117.109 201.872 117.911 201.633 118.906 201.633C119.901 201.633 120.693 201.878 121.281 202.367C121.875 202.857 122.172 203.513 122.172 204.336V210H120.555V208.648H120.516C120.281 209.102 119.924 209.464 119.445 209.734C118.971 210.005 118.464 210.141 117.922 210.141ZM124.305 199.836H126V201.781H127.562V203.117H126V207.648C126 208.003 126.081 208.263 126.242 208.43C126.404 208.596 126.656 208.68 127 208.68C127.25 208.68 127.435 208.667 127.555 208.641V209.977C127.346 210.029 127.034 210.055 126.617 210.055C125.789 210.055 125.195 209.885 124.836 209.547C124.482 209.203 124.305 208.633 124.305 207.836V203.117H123.109V201.781H124.305V199.836ZM135.117 209.016C134.409 209.776 133.464 210.156 132.281 210.156C131.099 210.156 130.154 209.776 129.445 209.016C128.737 208.25 128.383 207.208 128.383 205.891C128.383 204.578 128.737 203.542 129.445 202.781C130.154 202.016 131.099 201.633 132.281 201.633C133.464 201.633 134.409 202.016 135.117 202.781C135.826 203.542 136.18 204.578 136.18 205.891C136.18 207.208 135.826 208.25 135.117 209.016ZM132.281 208.766C132.953 208.766 133.484 208.513 133.875 208.008C134.266 207.503 134.461 206.797 134.461 205.891C134.461 204.99 134.263 204.286 133.867 203.781C133.477 203.276 132.948 203.023 132.281 203.023C131.615 203.023 131.083 203.276 130.688 203.781C130.297 204.286 130.102 204.99 130.102 205.891C130.102 206.797 130.297 207.503 130.688 208.008C131.083 208.513 131.615 208.766 132.281 208.766ZM137.484 210V201.781H139.094V203.18H139.133C139.268 202.701 139.51 202.326 139.859 202.055C140.208 201.784 140.625 201.648 141.109 201.648C141.271 201.648 141.464 201.669 141.688 201.711V203.281C141.536 203.219 141.284 203.188 140.93 203.188C140.388 203.188 139.958 203.357 139.641 203.695C139.328 204.034 139.172 204.495 139.172 205.078V210H137.484ZM142.586 204.109C142.586 203.375 142.883 202.779 143.477 202.32C144.07 201.862 144.846 201.633 145.805 201.633C146.716 201.633 147.464 201.865 148.047 202.328C148.635 202.786 148.943 203.383 148.969 204.117H147.383C147.341 203.742 147.177 203.448 146.891 203.234C146.604 203.021 146.227 202.914 145.758 202.914C145.299 202.914 144.93 203.016 144.648 203.219C144.372 203.422 144.234 203.685 144.234 204.008C144.234 204.508 144.654 204.862 145.492 205.07L146.875 205.391C147.703 205.589 148.289 205.859 148.633 206.203C148.982 206.542 149.156 207.016 149.156 207.625C149.156 208.375 148.839 208.984 148.203 209.453C147.573 209.922 146.753 210.156 145.742 210.156C144.779 210.156 143.992 209.927 143.383 209.469C142.779 209.01 142.443 208.401 142.375 207.641H144.047C144.115 208.036 144.299 208.341 144.602 208.555C144.904 208.763 145.31 208.867 145.82 208.867C146.326 208.867 146.724 208.771 147.016 208.578C147.312 208.38 147.461 208.115 147.461 207.781C147.461 207.516 147.372 207.305 147.195 207.148C147.018 206.992 146.716 206.859 146.289 206.75L144.82 206.391C143.331 206.031 142.586 205.271 142.586 204.109ZM154.531 213.062C154.214 213.062 153.984 213.049 153.844 213.023V211.656C153.927 211.677 154.109 211.688 154.391 211.688C154.786 211.688 155.096 211.596 155.32 211.414C155.544 211.237 155.721 210.938 155.852 210.516C155.852 210.51 155.878 210.424 155.93 210.258L156 210.008L153.031 201.781H154.859L156.945 208.469H156.969L159.055 201.781H160.836L157.75 210.43C157.401 211.424 156.992 212.112 156.523 212.492C156.055 212.872 155.391 213.062 154.531 213.062ZM167.961 209.016C167.253 209.776 166.307 210.156 165.125 210.156C163.943 210.156 162.997 209.776 162.289 209.016C161.581 208.25 161.227 207.208 161.227 205.891C161.227 204.578 161.581 203.542 162.289 202.781C162.997 202.016 163.943 201.633 165.125 201.633C166.307 201.633 167.253 202.016 167.961 202.781C168.669 203.542 169.023 204.578 169.023 205.891C169.023 207.208 168.669 208.25 167.961 209.016ZM165.125 208.766C165.797 208.766 166.328 208.513 166.719 208.008C167.109 207.503 167.305 206.797 167.305 205.891C167.305 204.99 167.107 204.286 166.711 203.781C166.32 203.276 165.792 203.023 165.125 203.023C164.458 203.023 163.927 203.276 163.531 203.781C163.141 204.286 162.945 204.99 162.945 205.891C162.945 206.797 163.141 207.503 163.531 208.008C163.927 208.513 164.458 208.766 165.125 208.766ZM177.375 201.781V210H175.758V208.609H175.719C175.245 209.635 174.396 210.148 173.172 210.148C172.276 210.148 171.57 209.878 171.055 209.336C170.544 208.789 170.289 208.044 170.289 207.102V201.781H171.977V206.773C171.977 207.404 172.125 207.883 172.422 208.211C172.719 208.534 173.156 208.695 173.734 208.695C174.339 208.695 174.815 208.503 175.164 208.117C175.513 207.732 175.688 207.216 175.688 206.57V201.781H177.375ZM182.148 204.109C182.148 203.375 182.445 202.779 183.039 202.32C183.633 201.862 184.409 201.633 185.367 201.633C186.279 201.633 187.026 201.865 187.609 202.328C188.198 202.786 188.505 203.383 188.531 204.117H186.945C186.904 203.742 186.74 203.448 186.453 203.234C186.167 203.021 185.789 202.914 185.32 202.914C184.862 202.914 184.492 203.016 184.211 203.219C183.935 203.422 183.797 203.685 183.797 204.008C183.797 204.508 184.216 204.862 185.055 205.07L186.438 205.391C187.266 205.589 187.852 205.859 188.195 206.203C188.544 206.542 188.719 207.016 188.719 207.625C188.719 208.375 188.401 208.984 187.766 209.453C187.135 209.922 186.315 210.156 185.305 210.156C184.341 210.156 183.555 209.927 182.945 209.469C182.341 209.01 182.005 208.401 181.938 207.641H183.609C183.677 208.036 183.862 208.341 184.164 208.555C184.466 208.763 184.872 208.867 185.383 208.867C185.888 208.867 186.286 208.771 186.578 208.578C186.875 208.38 187.023 208.115 187.023 207.781C187.023 207.516 186.935 207.305 186.758 207.148C186.581 206.992 186.279 206.859 185.852 206.75L184.383 206.391C182.893 206.031 182.148 205.271 182.148 204.109ZM194.898 203.586C194.529 203.19 194.052 202.992 193.469 202.992C192.885 202.992 192.401 203.193 192.016 203.594C191.63 203.99 191.417 204.503 191.375 205.133H195.484C195.464 204.497 195.268 203.982 194.898 203.586ZM195.477 207.586H197.078C196.958 208.341 196.573 208.958 195.922 209.438C195.271 209.917 194.477 210.156 193.539 210.156C192.336 210.156 191.388 209.779 190.695 209.023C190.008 208.263 189.664 207.232 189.664 205.93C189.664 204.638 190.008 203.599 190.695 202.812C191.388 202.026 192.312 201.633 193.469 201.633C194.604 201.633 195.505 202.005 196.172 202.75C196.839 203.49 197.172 204.484 197.172 205.734V206.312H191.367V206.414C191.367 207.133 191.568 207.708 191.969 208.141C192.37 208.573 192.906 208.789 193.578 208.789C194.052 208.789 194.458 208.68 194.797 208.461C195.135 208.242 195.362 207.951 195.477 207.586ZM198.547 210V198.727H200.234V210H198.547ZM206.836 203.586C206.466 203.19 205.99 202.992 205.406 202.992C204.823 202.992 204.339 203.193 203.953 203.594C203.568 203.99 203.354 204.503 203.312 205.133H207.422C207.401 204.497 207.206 203.982 206.836 203.586ZM207.414 207.586H209.016C208.896 208.341 208.51 208.958 207.859 209.438C207.208 209.917 206.414 210.156 205.477 210.156C204.273 210.156 203.326 209.779 202.633 209.023C201.945 208.263 201.602 207.232 201.602 205.93C201.602 204.638 201.945 203.599 202.633 202.812C203.326 202.026 204.25 201.633 205.406 201.633C206.542 201.633 207.443 202.005 208.109 202.75C208.776 203.49 209.109 204.484 209.109 205.734V206.312H203.305V206.414C203.305 207.133 203.505 207.708 203.906 208.141C204.307 208.573 204.844 208.789 205.516 208.789C205.99 208.789 206.396 208.68 206.734 208.461C207.073 208.242 207.299 207.951 207.414 207.586ZM217.477 204.609H215.867C215.779 204.146 215.565 203.768 215.227 203.477C214.893 203.185 214.464 203.039 213.938 203.039C213.281 203.039 212.755 203.297 212.359 203.812C211.969 204.323 211.773 205.016 211.773 205.891C211.773 206.781 211.969 207.479 212.359 207.984C212.755 208.49 213.286 208.742 213.953 208.742C214.469 208.742 214.891 208.609 215.219 208.344C215.552 208.073 215.768 207.698 215.867 207.219H217.492C217.404 208.099 217.034 208.81 216.383 209.352C215.737 209.888 214.922 210.156 213.938 210.156C212.755 210.156 211.812 209.776 211.109 209.016C210.406 208.25 210.055 207.208 210.055 205.891C210.055 204.589 210.406 203.555 211.109 202.789C211.812 202.018 212.75 201.633 213.922 201.633C214.943 201.633 215.771 201.919 216.406 202.492C217.042 203.06 217.398 203.766 217.477 204.609ZM219.18 199.836H220.875V201.781H222.438V203.117H220.875V207.648C220.875 208.003 220.956 208.263 221.117 208.43C221.279 208.596 221.531 208.68 221.875 208.68C222.125 208.68 222.31 208.667 222.43 208.641V209.977C222.221 210.029 221.909 210.055 221.492 210.055C220.664 210.055 220.07 209.885 219.711 209.547C219.357 209.203 219.18 208.633 219.18 207.836V203.117H217.984V201.781H219.18V199.836ZM228.492 203.586C228.122 203.19 227.646 202.992 227.062 202.992C226.479 202.992 225.995 203.193 225.609 203.594C225.224 203.99 225.01 204.503 224.969 205.133H229.078C229.057 204.497 228.862 203.982 228.492 203.586ZM229.07 207.586H230.672C230.552 208.341 230.167 208.958 229.516 209.438C228.865 209.917 228.07 210.156 227.133 210.156C225.93 210.156 224.982 209.779 224.289 209.023C223.602 208.263 223.258 207.232 223.258 205.93C223.258 204.638 223.602 203.599 224.289 202.812C224.982 202.026 225.906 201.633 227.062 201.633C228.198 201.633 229.099 202.005 229.766 202.75C230.432 203.49 230.766 204.484 230.766 205.734V206.312H224.961V206.414C224.961 207.133 225.161 207.708 225.562 208.141C225.964 208.573 226.5 208.789 227.172 208.789C227.646 208.789 228.052 208.68 228.391 208.461C228.729 208.242 228.956 207.951 229.07 207.586ZM235.164 210.141C234.122 210.141 233.286 209.755 232.656 208.984C232.026 208.214 231.711 207.182 231.711 205.891C231.711 204.599 232.023 203.57 232.648 202.805C233.279 202.034 234.112 201.648 235.148 201.648C235.727 201.648 236.242 201.784 236.695 202.055C237.148 202.32 237.492 202.685 237.727 203.148H237.758V198.727H239.453V210H237.812V208.602H237.781C237.536 209.081 237.185 209.458 236.727 209.734C236.273 210.005 235.753 210.141 235.164 210.141ZM235.609 203.07C234.943 203.07 234.414 203.326 234.023 203.836C233.633 204.341 233.438 205.026 233.438 205.891C233.438 206.76 233.633 207.448 234.023 207.953C234.414 208.458 234.943 208.711 235.609 208.711C236.26 208.711 236.784 208.456 237.18 207.945C237.576 207.43 237.773 206.745 237.773 205.891C237.773 205.042 237.576 204.359 237.18 203.844C236.784 203.328 236.26 203.07 235.609 203.07Z" fill="#2C2C2C"/>
          <rect x="67.457" y="57.7501" width="6.64666" height="1" rx="0.5" transform="rotate(45 67.457 57.7501)" stroke="#DEE3EA"/>
          <rect x="72.1972" y="58.4141" width="6.76436" height="1" rx="0.5" transform="rotate(135 72.1972 58.4141)" stroke="#DEE3EA"/>
          <rect x="277.414" y="15.7071" width="9" height="1" rx="0.5" transform="rotate(45 277.414 15.7071)" stroke="#DEE3EA"/>
          <rect x="283.777" y="16.4141" width="9" height="1" rx="0.5" transform="rotate(135 283.777 16.4141)" stroke="#DEE3EA"/>
          <rect x="306.414" y="138.707" width="9" height="1" rx="0.5" transform="rotate(45 306.414 138.707)" stroke="#DEE3EA"/>
          <rect x="312.777" y="139.414" width="9" height="1" rx="0.5" transform="rotate(135 312.777 139.414)" stroke="#DEE3EA"/>
          <rect x="121.487" y="102.167" width="76.0253" height="0.974684" rx="0.487342" stroke="#DEE3EA" stroke-width="0.974684"/>
          <path d="M137.571 100.706V85.1875C137.571 83.5306 136.228 82.1875 134.571 82.1875H127.9C126.244 82.1875 124.9 83.5306 124.9 85.1875V100.706" stroke="#DEE3EA" stroke-width="2"/>
          <path d="M174.606 100.706V85.1875C174.606 83.5306 173.263 82.1875 171.606 82.1875H164.936C163.279 82.1875 161.936 83.5306 161.936 85.1875V100.706" stroke="#DEE3EA" stroke-width="2"/>
          <path d="M156.087 100.707V73.4922C156.087 71.8353 154.744 70.4922 153.087 70.4922H146.416C144.759 70.4922 143.416 71.8353 143.416 73.4922V100.707" stroke="#DEE3EA" stroke-width="2"/>
          <path d="M193.126 100.707V73.4922C193.126 71.8353 191.783 70.4922 190.126 70.4922H183.455C181.798 70.4922 180.455 71.8353 180.455 73.4922V100.707" stroke="#DEE3EA" stroke-width="2"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M20 27.2C20.6627 27.2 21.2 26.6627 21.2 26C21.2 25.3373 20.6627 24.8 20 24.8C19.3373 24.8 18.8 25.3373 18.8 26C18.8 26.6627 19.3373 27.2 20 27.2ZM20 29C21.6569 29 23 27.6569 23 26C23 24.3431 21.6569 23 20 23C18.3431 23 17 24.3431 17 26C17 27.6569 18.3431 29 20 29Z" fill="#DEE3EA"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M262 93.2C262.663 93.2 263.2 92.6627 263.2 92C263.2 91.3373 262.663 90.8 262 90.8C261.337 90.8 260.8 91.3373 260.8 92C260.8 92.6627 261.337 93.2 262 93.2ZM262 95C263.657 95 265 93.6569 265 92C265 90.3431 263.657 89 262 89C260.343 89 259 90.3431 259 92C259 93.6569 260.343 95 262 95Z" fill="#DEE3EA"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M23 136.2C23.6627 136.2 24.2 135.663 24.2 135C24.2 134.337 23.6627 133.8 23 133.8C22.3373 133.8 21.8 134.337 21.8 135C21.8 135.663 22.3373 136.2 23 136.2ZM23 138C24.6569 138 26 136.657 26 135C26 133.343 24.6569 132 23 132C21.3431 132 20 133.343 20 135C20 136.657 21.3431 138 23 138Z" fill="#DEE3EA"/>
          <rect x="93" y="34" width="134" height="86" rx="9" stroke="#DEE3EA" stroke-width="2"/>
          <rect x="143.5" y="130.5" width="33" height="1" rx="0.5" stroke="#DEE3EA"/>
          <rect x="160.5" y="119.5" width="12" height="1" rx="0.5" transform="rotate(90 160.5 119.5)" stroke="#DEE3EA"/>
          <circle cx="130.335" cy="67.6963" r="2.77049" stroke="#DEE3EA" stroke-width="2"/>
          <circle cx="148.804" cy="54.7705" r="2.77049" stroke="#DEE3EA" stroke-width="2"/>
          <circle cx="168.27" cy="67.6963" r="2.77049" stroke="#DEE3EA" stroke-width="2"/>
          <circle cx="185.741" cy="54.7705" r="2.77049" stroke="#DEE3EA" stroke-width="2"/>
          <path d="M132.415 66.3769L147 55.9988" stroke="#DEE3EA" stroke-width="2"/>
          <path d="M171.216 66.482L183.999 56.0016" stroke="#DEE3EA" stroke-width="2"/>
          <path d="M151.001 55.9999L166.554 66.7555" stroke="#DEE3EA" stroke-width="2"/>
        </svg>
      </section>
      <transition name="fade">
        <section class="wrap-loading" v-if="getStatusRequestFilter !== 0">

          <!--        <div class="sk-fading-circle">-->
          <!--          <div class="sk-circle sk-circle-1"></div>-->
          <!--          <div class="sk-circle sk-circle-2"></div>-->
          <!--          <div class="sk-circle sk-circle-3"></div>-->
          <!--          <div class="sk-circle sk-circle-4"></div>-->
          <!--          <div class="sk-circle sk-circle-5"></div>-->
          <!--          <div class="sk-circle sk-circle-6"></div>-->
          <!--          <div class="sk-circle sk-circle-7"></div>-->
          <!--          <div class="sk-circle sk-circle-8"></div>-->
          <!--          <div class="sk-circle sk-circle-9"></div>-->
          <!--          <div class="sk-circle sk-circle-10"></div>-->
          <!--          <div class="sk-circle sk-circle-11"></div>-->
          <!--          <div class="sk-circle sk-circle-12"></div>-->
          <!--        </div>-->
          <div class="holder">
            <!--        {{getStatusRequestFilter}}-->
            <div class="preloader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
          </div>
        </section>
      </transition>

    </div>

    <div class="block-average" v-if="!average">
      <p class="text-gray fz12">Average</p>
      <div class="block-average__main">
        <p class="fz13 fw500 text-gray" v-for="(item, i) in getAverageOverlay()" :key="i">{{item.name}}: <span class="fz13 fw500 text-dark"> {{ item.amount }}</span></p>
      </div>
    </div>
  </div>
</template>

<script>

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import moment from 'moment'
// Importing themes
// import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import {mapGetters} from "vuex";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
// import am4themes_dark from "@amcharts/amcharts4/themes/dark";

// Importing translations
// import am4lang_lt_LT from "@amcharts/amcharts4/lang/lt_LT";

// Importing geodata (map data)
// import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
export default {
  computed: mapGetters(["getDataFilter", "getStatusRequestFilter", "getYearForFilter", 'getDataFilterInQueue']),
  name: "lineChartTest",
  props: ['type', 'monthActive', 'showTable'],
  watch: {
    type: function () {
      this.createChart()
    },
    average: function () {
      this.createChart()

    },
    showTable: function () {
      this.resizeChart()
    }
  },
  data() {
    return  {
      valueAxis: null,
      indicator: null,
      chart: null,
      arraySeries: [],
      stroke: [],
      noData: false,
      arraySeriesAdding: [],
      average: true,
      dateAxis: null,
      // colorStroke: ["rgb(128,0,0)", "rgb(255,0,0)", "rgb(250,128,114)", ""]
      colorsForLine: ["#FFAB91", "#6F9FC4", "#569567", "#AC4C4C",
        "#876DB3", "#B05C91", "#E9C127", "#2DCA73",
        "#1BBFD4", "#5F81FF", "#7551E9", "#F8306D",
        "#C77BB1", "#094172", "#E85353", "#319FEF",
        "#FF833E", "#0FA54E", "#00E5FF", "#7986CB",
        "#F06292", "#8D6E63", "#EE82EE",
        "#4B0082", "#6A5ACD", "#90EE90", "#6B8E23",
        "#F0E68C", "#CD853F", "#F08080", "#DC143C",
        "#000080", "#00FFFF", "#32CD32", "#FFFF00",
        "#000000", "#808080", "#BC8F8F", "#9400D3",
        "#008B8B", "#20B2AA", "#E6E6FA", "#556B2F"],
    }
  },
  methods: {
    resizeChart() {
      this.chart.svgContainer.measure()
    },
    createChart() {
      if(this.average) {
        this.dateAxis.periodChangeDateFormats.setKey("month", "[bold]YYYY[/]");
        this.clearChart();
        this.clearDataChart()
        this.setDataChartInQueue();
        this.createSeries('valueInQueue', '', null)
        this.createSeriesAdding1("additional1", "s1");
        this.createSeriesAdding("additional", "s");
        this.getTolltipe();
        // setTimeout(()=> {
        //   this.dateAxis.zoomToDates(new Date(this.getDataFilterInQueue.data[0]), new Date(this.getDataFilterInQueue.data[this.getDataFilterInQueue.data.length-1]));
        // }, 5000)
      } else {
        this.dateAxis.periodChangeDateFormats.setKey("month", " ");
        this.clearChart();
        this.clearDataChart()
        if(this.type === 'Bars' || this.type === 'Candles' || this.type === 'Filled Candles' || this.type === 'Hollow Candles') {
          this.setDataChartInQueue();
        } else {
          this.setDataChart();
        }
        this.addSeries();
        this.getTolltipe();
        if(this.type === 'Bars' || this.type === 'Candles' || this.type === 'Filled Candles' || this.type === 'Hollow Candles') {
          // setTimeout(()=> {
          //   this.dateAxis.zoomToDates(new Date(this.getDataFilterInQueue.data[0]), new Date(this.getDataFilterInQueue.data[this.getDataFilterInQueue.data.length-1]));
          // }, 5000)
        } else{
          // setTimeout(()=> {
          //   this.dateAxis.zoomToDates(new Date(this.getDataFilter.data[0]), new Date(this.getDataFilter.data[this.getDataFilter.data.length-1]));
          // }, 5000)
        }

      }
      setTimeout(()=> {
        this.chart.svgContainer.measure();
        this.valueAxis.zoomToValues( this.valueAxis.min, this.valueAxis.max)
      }, 300)
      setTimeout(()=> {
        // let vm=this
        // chart.events.on("ready", function() {
        //   vm.valueAxis.min = vm.valueAxis.minZoomed;
        //   vm.valueAxis.max = vm.valueAxis.maxZoomed;
        // });
        // this.dateAxis.zoomToDates(new Date(this.chart.data[0]), new Date(this.chart.data[this.chart.data.length-1]));
        // this.valueAxis.min = this.valueAxis.minZoomed
        // this.valueAxis.max = this.valueAxis.maxZoomed
        // this.valueAxis.zoomToValues(this.valueAxis.minZoomed, this.valueAxis.maxZoomed)
        // console.log(this.valueAxis.minZoomed, this.valueAxis.maxZoomed)
        // this.chart.svgContainer.measure();
        this.valueAxis.zoomToValues( this.valueAxis.min, this.valueAxis.max)
        console.log(' this.chart.data', this.valueAxis.min, this.valueAxis.max, this.valueAxis.minZoomed, this.valueAxis.maxZoomed)
      }, 5000)


    },
    getAverageOverlay() {
      let array = [];
      if(this.getDataFilter?.data?.length) {
        this.getDataFilter.nameLines.map(a=> {
          array.push({name: a, amount: 0, count: 0})
        })
        this.getDataFilter.data.map(a=> {
          for(let i=0; i<array.length; i++) {
            // if((''+a.date).indexOf(array[i].name) >= 0) {
            if(a['value'+array[i].name]) {
              array[i].amount+=a['value'+array[i].name];
              array[i].count++;
            }
          }
        })
        array = array.map(a=> {
          let month = "";
          if(this.monthActive?.length !== 12 && this.monthActive?.length !== 1 && this.monthActive?.length !== 0) {
            month = this.monthActive[0].name + '-' + this.monthActive[this.monthActive.length -1].name + " ";
          }
          a.name = month+a.name;
          a.amount = Math.round(((a.amount/a.count))*100)/100
          return a
        })
      }
      return array;
    },
    getAverageInQueue() {
      let amount = 0;
      if(this.getDataFilterInQueue?.data?.length) {
        this.getDataFilterInQueue.data.map(a=> {
          amount+=a.valueInQueue;
        })
        amount = Math.round((amount/this.getDataFilterInQueue.data.length)*100)/100
      }
      return amount
    },
    changeAverageStatus(data) {
      this.average = data;
    },
    addTextForDotsLine(data) {
      // console.log(this.chart.data)
      for(let i=0; i<this.chart.data.length; i++) {
        if(moment(data.date).format('MM-DD') === moment(this.chart.data[i].date).format('MM-DD')) {
          if(this.chart.data[i]["showTooltip"] === "always") {
            this.chart.data[i]["showTooltip"] = "";
          } else {
            this.chart.data[i]["showTooltip"] = "always";
          }
        }
      }
      // this.chart.data.forEach((item)=> {
      //   if(moment(data.date).format('YYYY-MM-DD') === moment(item.date).format('YYYY-MM-DD')) {
      //     console.log(moment(data.date).format('YYYY-MM-DD') === moment(item.date).format('YYYY-MM-DD'))
      //
      //     item["showTooltip"] !== "always" ? item["showTooltip"] === "always" : item["showTooltip"] === "";
      //   }
      // })
      // console.log(this.chart.data)
      this.chart.invalidateData();

    },
    showIndicator() {
      this.indicator = this.chart.tooltipContainer.createChild(am4core.Container);
      this.indicator.background.fill = am4core.color("#fff");
      // this.indicator.background.fillOpacity = 0.8;
      this.indicator.background.fillOpacity = 1;
      this.indicator.width = am4core.percent(100);
      this.indicator.height = am4core.percent(100);

      var indicatorLabel =  this.indicator.createChild(am4core.Label);
      indicatorLabel.text = "Chart changing...";
      indicatorLabel.align = "center";
      indicatorLabel.valign = "middle";
      indicatorLabel.fontSize = 20;
    },
    hideIndicator() {
      this.indicator.hide();
    },
    clearDataChart() {
      this.chart.data.splice(0,this.chart.data.length);
      // let vm = this;
      this.arraySeries.splice(0,this.arraySeries.length);
      this.arraySeriesAdding.splice(0,this.arraySeriesAdding.length);
      this.noData = true;
    },
    clearChart() {
      for(let i=0; i<this.arraySeries.length; i++) {
        this.chart.series.removeIndex(0);
      }
      for(let i=0; i<this.arraySeriesAdding.length; i++) {
        this.chart.series.removeIndex(0);
      }
      this.stroke.splice(0,this.stroke.length);
      this.noData = true;
      this.arraySeriesAdding.splice(0, this.arraySeriesAdding.length);
      this.arraySeries.splice(0, this.arraySeries.length);
    },
    setDataChart() {
      this.chart.data = JSON.parse(JSON.stringify(this.getDataFilter.data));
      // this.chart.invalidate();
      // console.log(new Date('2012-01-01 00:00'))
      // console.log(this.getDataFilter.data)
      for(let i=0; i<this.chart.data.length; i++) {
        this.chart.data[i].date = moment.utc(this.chart.data[i].date).toDate();
      }
      // console.log('this.chart.data')
      // console.log(this.chart.data)
      this.arraySeriesAdding.splice(0, this.arraySeriesAdding.length);
      this.arraySeries.splice(0, this.arraySeries.length);
      if(this.chart.data.length !==0) {
        this.noData = false;
      }
    },
    setDataChartInQueue() {
      this.chart.data = JSON.parse(JSON.stringify(this.getDataFilterInQueue.data));
      // this.chart.data = [
      //   {
      //     "date": "2022-01-17T00:00:00.000Z",
      //     "valueInQueue": 32423,
      //     "valueInQueueYesterday": 0,
      //     "showTooltip": "",
      //     "additional": 32423,
      //     "additional1": 10
      //   },
      //   {
      //     "date": "2022-01-19T00:00:00.000Z",
      //     "valueInQueue": 121,
      //     "valueInQueueYesterday": 32423,
      //     "showTooltip": "",
      //     "additional": 10,
      //     "additional1": 10
      //   },
      //   {
      //     "date": "2022-02-15T00:00:00.000Z",
      //     "valueInQueue": 23,
      //     "valueInQueueYesterday": 121,
      //     "showTooltip": "",
      //     "additional": 10,
      //     "additional1": 10
      //   },
      //   {
      //     "date": "2022-02-20T00:00:00.000Z",
      //     "valueInQueue": 2543,
      //     "valueInQueueYesterday": 23,
      //     "showTooltip": "",
      //     "additional": 10,
      //     "additional1": 10
      //   },
      //   {
      //     "date": "2022-04-20T00:00:00.000Z",
      //     "valueInQueue": 6,
      //     "valueInQueueYesterday": 2543,
      //     "showTooltip": "",
      //     "additional": 32423,
      //     "additional1": 10
      //   }
      // ]
      // this.chart.invalidate();

      // console.log(this.getDataFilterInQueue.data)
      for(let i=0; i<this.chart.data.length; i++) {
        this.chart.data[i].date = moment.utc(this.chart.data[i].date).toDate();
      }
      // for(let i=0; i<this.chart.data.length; i++) {
      //   this.chart.data[i].date = new Date(this.chart.data[i].date);
      // }
      console.log("this.chart.data")
      console.log(  this.chart.data)
      this.arraySeriesAdding.splice(0, this.arraySeriesAdding.length);
      this.arraySeries.splice(0, this.arraySeries.length);
      if(this.chart.data.length !==0) {
        this.noData = false;
      }

      // function createSeries(field, name) {
      //   var series = this.chart.series.push(new am4charts.LineSeries());
      //   series.dataFields.valueY = field;
      //   series.dataFields.dateX = "date";
      //   series.name = name;
      //   series.tooltipText = "{dateX}: [b]{valueY}[/]";
      //   series.strokeWidth = 2;
      //
      //   series.smoothing = "monotoneX";
      //
      //   var bullet = series.bullets.push(new am4charts.CircleBullet());
      //   bullet.circle.stroke = am4core.color("#fff");
      //   bullet.circle.strokeWidth = 2;
      //
      //   return series;
      // }
      //
      // createSeries("valueInQueue", "Series #1");
      setTimeout(()=> {
        // let vm=this
        // chart.events.on("ready", function() {
        //   vm.valueAxis.min = vm.valueAxis.minZoomed;
        //   vm.valueAxis.max = vm.valueAxis.maxZoomed;
        // });
        // this.dateAxis.zoomToDates(new Date(this.chart.data[0]), new Date(this.chart.data[this.chart.data.length-1]));
        // this.valueAxis.min = this.valueAxis.minZoomed
        // this.valueAxis.max = this.valueAxis.maxZoomed
        this.valueAxis.zoomToValues( this.valueAxis.min, this.valueAxis.max)
        // console.log(this.valueAxis.minZoomed, this.valueAxis.maxZoomed)
        // this.chart.svgContainer.measure();
        console.log(' this.chart.data', this.valueAxis.min, this.valueAxis.max, this.valueAxis.minZoomed, this.valueAxis.maxZoomed)
      }, 5000)
    },
    addSeries() {
      // // console.log("add");
      // // console.log("aaaa");
      if(this.type !== 'Bars' && this.type !== 'Candles' && this.type !== 'Filled Candles' && this.type !== 'Hollow Candles') {
        for(let i=0; i<this.getDataFilter.nameLines.length; i++) {
          let color = null;
          for(let j=0; j<this.getYearForFilter.length; j++) {
            if(this.getDataFilter.nameLines[i] === this.getYearForFilter[j].name) {
              color = this.colorsForLine[j];
            }
          }
          this.createSeries(this.getDataFilter.valueLines[i], this.getDataFilter.nameLines[i], color);
        }
      } else {
        this.createSeries(['valueInQueueYesterday', 'valueInQueue'], this.getDataFilter.nameLines, null);
      }


      this.createSeriesAdding1("additional1", "s1");
      this.createSeriesAdding("additional", "s");


      // for(let i=0; i< 2; i++) {
      //   if(i===0) {
      //     this.createSeriesAdding("additional", "s");
      //
      //   }
      //   if(i===1) {
      //     this.createSeriesAdding1("additional1", "s1");
      //
      //   }
      // }
      // for(let i=0; i<this.arraySeries.length; i++) {
      //   // console.log(this.arraySeries[i]);
      // }
      // // console.log("endFor")
      this.chart.cursor = new am4charts.XYCursor();
      this.chart.plotContainer.tooltipPosition = "pointer"
      this.chart.plotContainer.tooltipText = ".";
      this.chart.plotContainer.tooltip["getFillFromObject"] = false;
      this.chart.plotContainer.tooltip.background.fill = am4core.color("rgba(255,255,255,1)");
      this.chart.plotContainer.tooltip.background.fillOpacity = 1;
      this.chart.plotContainer.tooltip.label.fontSize = 13;

      let vm = this;
      this.chart.cursor.events.on("cursorpositionchanged", function(ev) {
        let xAxis = ev.target.chart.xAxes.getIndex(0);
        var YDateHover = xAxis.positionToDate(xAxis.toAxisPosition(ev.target.xPosition));
        let index = 0;
        // // console.log(1);
        // // console.log(ev.target);
        // // console.log(11);
        for(let i=0; i<vm.chart.data.length; i++) {
          // // console.log(2);
          // // console.log(vm.chart.data[i].date);
          // // console.log(new Date(vm.chart.data[i].date).getDate());
          if(YDateHover.getMonth() === vm.chart.data[i].date.getMonth() && YDateHover.getDate() === vm.chart.data[i].date.getDate()) {
            // // console.log(3);
            // // console.log("index: "+ i)
            index = i;
          }
        }
        let text = "";
        if(vm.arraySeries.length !== 0) {
          let item = vm.arraySeries[0].dataItems.getIndex(index);
          // // console.log("SERIES");
          // // console.log(vm.arraySeries);
          text = "[#9AA3B0]" + item.dateX.getDate() + ", " + item.dateX.toLocaleString('eng', {month: 'long'}) + "[/]\n";
          for (let i = 0; i < vm.arraySeries.length; i++) {
            item = vm.arraySeries[i].dataItems.getIndex(index);
            let value = item.valueY;
            if (value === undefined) {
              value = "\t—"
            }
            // // console.log(value);
            text += "[" + vm.arraySeries[i].stroke.hex + "]●[/] " + "[#9AA3B0]" + vm.arraySeries[i].name + ": " + "[/]" + "[#4B4B4B]" + vm.numberWithSpaces(value) + "[/]" + "\n";
          }
        }
        vm.chart.plotContainer.tooltipText = text;
      });
    },
    createSeries(field, name, color) {
      let series = null;
      if(this.type === 'Bars' || this.type === 'Candles' || this.type === 'Filled Candles' || this.type === 'Hollow Candles') {
        if(this.type === 'Candles' || this.type === 'Filled Candles' || this.type === 'Hollow Candles') {
          series = this.chart.series.push(new am4charts.CandlestickSeries());
        } else {
          series = this.chart.series.push(new am4charts.OHLCSeries());
        }
        series.dataFields.valueY = field[field.length - 1];
        if(Array.isArray(field) === true)
          if(field.length>1) {
            series.dataFields.openValueY = field[0];
            series.dataFields.lowValueY = field[0];
            series.dataFields.highValueY = field[field.length - 1];
          }
      } else {
        series = this.chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = field;
        series.name = name;
      }
      series.dataFields.dateX = "date";

      if(color !== null) {
        series.stroke = am4core.color(color);
        if(this.type === 'Area') {
          series.fill = am4core.color(color);
        }
      }
      series.fillOpacity = 0;
      if(this.type === 'Area') {
        // series.fillOpacity = 0.1;
        series.fillOpacity = 1;
      }
      if(this.type === 'Filled Candles') {
        series.fillOpacity = 1;
      }
      series.strokeWidth = 2;
      //Скругления графика
      // series.tensionX = 0.91;
      // series.tensionX = 1;
      series.tooltip["getFillFromObject"] = false;
      series.tooltip.background.fill = am4core.color("#fff");
      series.tooltip.label.fill = am4core.color("#00");
      series.tooltip.defaultState.transitionDuration = 0;
      series.tooltip.hiddenState.transitionDuration = 0;
      var bullet = series.bullets.push(new am4charts.CircleBullet());
      bullet.circle.strokeWidth = 2;
      bullet.fillOpacity = 0;
      bullet.strokeOpacity = 0;
      var bulletState = bullet.states.create("hover");
      bulletState.properties.fillOpacity = 1;
      bulletState.properties.strokeOpacity = 1;

      this.stroke.push(series.stroke.hex);
      this.arraySeries.push(series);
    },
    createSeriesAdding(field, name) {
      var series = this.chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = field;
      series.dataFields.dateX = "date";
      series.name = name;
      series.strokeWidth = 0;
      // series.fillOpacity = 1;
      // series.connect = false;
      //Скругления графика
      // series.tensionX = 0.91;
      // series.tensionX = 1;
      series.tooltip["getFillFromObject"] = false;
      series.tooltip.background.fill = am4core.color("#fff");
      series.tooltip.label.fill = am4core.color("#00");
      // Prevent cross-fading of tooltips
      series.tooltip.defaultState.transitionDuration = 0;
      series.tooltip.hiddenState.transitionDuration = 0;
      // series.columns.tooltipText = "sadasdasdsad";
      var bullet = series.bullets.push(new am4charts.CircleBullet());
      bullet.circle.strokeWidth = 2;
      bullet.fillOpacity = 0;
      bullet.strokeOpacity = 0;
      bullet.tooltipText = ".";
      bullet.propertyFields.showTooltipOn = "showTooltip";
      let vm = this;
      this.arraySeriesAdding.push(series);
      // Set up tooltip
      bullet.adapter.add("tooltipText", function() {
        var text = "[bold]{dateX.formatDate('d MMMM')}[/]\n"

        vm.chart.series.each(function(item) {
          if(item.name !== 's' && item.name !== 's1') {
            text += "[" + item.stroke.hex + "]●[/] " + item.name + ": {" + item.dataFields.valueY + "}\n";
            // text += "[" + item.stroke.hex + "]●[/] " + "[#9AA3B0]" + item.name + ": " + "[/]" + "[#4B4B4B]" + ": {" + item.dataFields.valueY + "}" + "[/]" + "\n";
          }
        });
        return text;
      });
      // bullet.tooltip["getFillFromObject"] = false;
      // bullet.tooltip.background.fill = am4core.color("rgba(255,255,255,1)");
      // bullet.tooltip.background.fillOpacity = 1;
      // bullet.tooltip.label.fontSize = 13;

    },
    createSeriesAdding1(field, name) {
      var series = this.chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = field;
      series.dataFields.dateX = "date";
      series.name = name;
      series.strokeWidth = 0;
      // series.fillOpacity = 1;
      // series.connect = false;
      //Скругления графика
      // series.tensionX = 0.91;
      // series.tensionX = 1;
      series.tooltip.background.fill = am4core.color("#fff");
      series.tooltip.label.fill = am4core.color("#00");
      // Prevent cross-fading of tooltips
      series.tooltip.defaultState.transitionDuration = 0;
      series.tooltip.hiddenState.transitionDuration = 0;
      // series.columns.tooltipText = "sadasdasdsad";
      var bullet = series.bullets.push(new am4charts.CircleBullet());
      bullet.circle.strokeWidth = 2;
      bullet.fillOpacity = 0;
      bullet.strokeOpacity = 0;
      this.arraySeriesAdding.push(series);

    },


    numberWithSpaces(value) {
      let fixedNumber = parseFloat(value)
      fixedNumber = fixedNumber ? fixedNumber : 0
      fixedNumber = fixedNumber.toLocaleString('en', {minimumFractionDigits: 2, maximumFractionDigits: 2})
      return fixedNumber
      // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    getTolltipe() {
      let vm = this;
      let chart = this.chart;
      function closest(array, date) {
        // let x = 8;
        // let array = [5, 10, 15, 20, 25, 30, 35];
        // let closest = array.sort( (a, b) => Math.abs(x - a) - Math.abs(x - b) )[0];
        // console.log(closest)
        return array.sort( (a, b) => Math.abs(moment(date).valueOf() - a.date) - Math.abs(moment(date).valueOf() - b.date) )[0].index;
      }
      chart.cursor.events.on("cursorpositionchanged", function(ev) {
        // if(vm.type !== 'Bars') {
        let xAxis = ev.target.chart.xAxes.getIndex(0);
        var YDateHover = xAxis.positionToDate(xAxis.toAxisPosition(ev.target.xPosition));
        // console.log('xAxis', YDateHover)

        let index = -1;
        if(vm.average || vm.type === 'Bars' || vm.type === 'Candles' || vm.type === 'Filled Candles' || vm.type === 'Hollow Candles') {
          for(let i=0; i<chart.data.length; i++) {
            if(YDateHover.getMonth() === chart.data[i].date.getMonth() && YDateHover.getDate() === chart.data[i].date.getDate() && YDateHover.getFullYear() === chart.data[i].date.getFullYear()) {
              index = i;
            }
          }
        } else {
          for(let i=0; i<chart.data.length; i++) {
            if(YDateHover.getMonth() === chart.data[i].date.getMonth() && YDateHover.getDate() === chart.data[i].date.getDate()) {
              index = i;
            }
          }
        }

        let dateIndexes = [];
        if(vm.arraySeries[0].dataItems._values[0].groupDataItems) {
          vm.arraySeries[0].dataItems._values.forEach((a, ind)=> {
            // console.log(a.dates.dateX, YDateHover)
            if(a.groupDataItems) {
              a.groupDataItems.forEach(b => {
                dateIndexes.push({date: moment(b.dates.dateX).valueOf(), index: ind})
              })
            }
            // } else {
            dateIndexes.push({date: moment(a.dates.dateX).valueOf(), index: ind})
            // }
          })
        }

        let groupDate = {from: null, to: null}
        if(vm.arraySeries[0].dataItems._values[0].groupDataItems) {
          // vm.arraySeries[0].dataItems._values.forEach((a, ind)=> {
          //   // console.log(a.dates.dateX, YDateHover)
          //   if(a.groupDataItems) {
          //     a.groupDataItems.forEach(b=> {
          //       // console.log(moment(b.dates.dateX, YDateHover)
          //       // console.log(b.dates.dateX, YDateHover)
          //       if(moment(b.dates.dateX).format('DD.MM.YYYY') == moment(YDateHover).format('DD.MM.YYYY')) {
          //         index = ind
          //         groupDate.from = a.groupDataItems[0].dates.dateX
          //         groupDate.to = a.groupDataItems[a.groupDataItems.length - 1].dates.dateX
          //         // console.log('INDEX', ind)
          //       }
          //     })
          //
          //   } else if(moment(a.dates.dateX).format('DD.MM.YYYY') == moment(YDateHover).format('DD.MM.YYYY')) {
          //     index = ind
          //     // console.log('INDEX', ind)
          //   }
          // })
          index = closest(dateIndexes,YDateHover)
          // console.log(closest(dateIndexes,YDateHover), groupDate)
        }
        // console.log('index', index)
        if(index === -1) {
          return;
        }
        let item = vm.arraySeries.length ? vm.arraySeries[0].dataItems.getIndex(index) : null;
        if(item.groupDataItems) {
          groupDate.from = item.groupDataItems[0].dates.dateX
          groupDate.to = item.groupDataItems[item.groupDataItems.length - 1].dates.dateX
        }
        let text = ""
        if(item) {
          if(vm.average || vm.type === 'Bars' || vm.type === 'Candles' || vm.type === 'Filled Candles' || vm.type === 'Hollow Candles') {
            if(groupDate.from && groupDate.to && groupDate.from !== groupDate.to) {
              text = "[#9AA3B0]" + moment(groupDate.from).format('D')+'-'+moment(groupDate.to).format('D') + ", " + groupDate.from.toLocaleString('eng', { month: 'long' }) + ' ' + item.dateX.getFullYear() + "[/]\n";
            } else {
              text = "[#9AA3B0]" + item.dateX.getDate() + ", " + item.dateX.toLocaleString('eng', { month: 'long' }) + ' ' + item.dateX.getFullYear() + "[/]\n";
            }
          } else {
            text = "[#9AA3B0]" + item.dateX.getDate() + ", " + item.dateX.toLocaleString('eng', { month: 'long' }) + "[/]\n";
          }
        }

        // console.log(vm.type);
        if(vm.type === "Line" || vm.type === 'Area') {
          for(let i=0; i<vm.arraySeries.length; i++) {
            // console.log()
            if( vm.arraySeries[i].dataItems._values[0].groupDataItems) {
              let dateIndexes = [];

              vm.arraySeries[i].dataItems._values.forEach((a, ind)=> {
                // // console.log(a.dates.dateX, YDateHover)
                // if(a.groupDataItems) {
                //   a.groupDataItems.forEach(b=> {
                //     // console.log(moment(b.dates.dateX, YDateHover)
                //     // console.log(b.dates.dateX, YDateHover)
                //     if(moment(b.dates.dateX).format('DD.MM.YYYY') == moment(YDateHover).format('DD.MM.YYYY')) {
                //       index = ind
                //       // console.log('INDEX', ind)
                //     }
                //   })
                //
                // } else if(moment(a.dates.dateX).format('DD.MM.YYYY') == moment(YDateHover).format('DD.MM.YYYY')) {
                //   index = ind
                //   // console.log('INDEX', ind)
                // }
                if(a.groupDataItems) {
                  a.groupDataItems.forEach(b => {
                    dateIndexes.push({date: moment(b.dates.dateX).valueOf(), index: ind})
                  })
                }
                dateIndexes.push({date: moment(a.dates.dateX).valueOf(), index: ind})
                // }
              })
              index = closest(dateIndexes,YDateHover)
            }
            // console.log(vm.arraySeries[i].dataItems._values)
            // console.log('index:', index)
            item = vm.arraySeries[i].dataItems.getIndex(index);
            // console.log('item',item)
            let value = item.valueY ? item.valueY : null;
            if(item.groupDataItems) {
              value = 0;
              item.groupDataItems.forEach(dot=> {
                value+= dot.valueY
              })
              value = value/item.groupDataItems.length
              // console.log('item.groupDataItems', item.groupDataItems)
            }
            if(!value) {
              continue
            }
            if(value === undefined) {
              value = "\t—"
            }
            if(vm.average) {
              text += "[" + vm.arraySeries[i].stroke.hex + "]●[/] " + "[#9AA3B0]" + moment(new Date(item.dateX)).format('YYYY') + ": " + "[/]" + "[#4B4B4B]" + vm.numberWithSpaces(value) + "[/]" + "\n";
            } else {
              text += "[" + vm.arraySeries[i].stroke.hex + "]●[/] " + "[#9AA3B0]" + vm.arraySeries[i].name + ": " + "[/]" + "[#4B4B4B]" + vm.numberWithSpaces(value) + "[/]" + "\n";
            }
          }
        } else {
          // console.log(index);
          let item = vm.arraySeries.length ? vm.arraySeries[0].dataItems.getIndex(index) : null;
          if(item) {
            let value = item.openValueY;
            if(value === undefined) {
              value = "\t—"
            }
            let item1 = vm.arraySeries[vm.arraySeries.length - 1].dataItems.getIndex(index);
            // console.log(item1)
            let value1 = item1.valueY;
            if(value1 === undefined) {
              value1 = "\t—"
            }
            text +=  "[#9AA3B0]" + 'Open' + ": " + "[/]" + "[#4B4B4B]" + vm.numberWithSpaces(value) + "[/]" + "\n";
            // text +=  "[#9AA3B0]" + 'Low' + ": " + "[/]" + "[#4B4B4B]" + vm.numberWithSpaces(value) + "[/]" + "\n"
            // text +=  "[#9AA3B0]" + 'High' + ": " + "[/]" + "[#4B4B4B]" + vm.numberWithSpaces(value1) + "[/]" + "\n"
            text +=  "[#9AA3B0]" + 'Close' + ": " + "[/]" + "[#4B4B4B]" + vm.numberWithSpaces(value1) + "[/]" + "\n"
          }

        }

        chart.plotContainer.tooltipText = text;
        // }
      });


    }
  },
  destroyed() {
    am4core.useTheme(am4themes_animated);
  },
  mounted() {
    // let x = 8;
    // let array = [5, 10, 15, 20, 25, 30, 35];
    // let closest = array.sort( (a, b) => Math.abs(x - a) - Math.abs(x - b) )[0];
    // console.log(closest)
    let vm = this;
    window.addEventListener('resize', function() {
      if(vm.$route.path.indexOf('baltic-dry-index') >=0) {
        vm.chart.svgContainer.measure()
      }
    }, true);
    am4core.unuseAllThemes()

    this.chart = am4core.create("chartdiv", am4charts.XYChart);
    let chart = this.chart;
    chart.svgContainer.autoResize = false;

    chart.paddingRight = 20;
    am4core.options.autoSetClassName = true;
    chart.data = [];


// Create axes
    this.dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
    this.dateAxis.skipEmptyPeriods = true;
    this.dateAxis.groupData = true;
    // this.dateAxis.groupCount = 500;

    this.dateAxis.dateFormats.setKey("day", "dd");
    this.dateAxis.dateFormats.setKey("month", "MMM");
    this.dateAxis.dateFormats.setKey("year", "YYYY");
    this.dateAxis.periodChangeDateFormats.setKey("day", "[bold]MMM[/]");
    this.dateAxis.periodChangeDateFormats.setKey("month", "[bold]YYYY[/]");
    this.dateAxis.groupCount = 100;
    // this.dateAxis.gridIntervals.setAll([
    //   { timeUnit: "day", count: 1 },
    //   // { timeUnit: "day", count: 2 },
    //   // { timeUnit: "day", count: 3 },
    //   // { timeUnit: "day", count: 4 },
    //   { timeUnit: "day", count: 5 },
    //   { timeUnit: "month", count: 1 },
    //   { timeUnit: "month", count: 2 },
    //   { timeUnit: "month", count: 3 },
    //   { timeUnit: "month", count: 6 },
    //   { timeUnit: "month", count: 12 },
    //   { timeUnit: "year", count: 1 },
    //   { timeUnit: "year", count: 2 },
    //   { timeUnit: "year", count: 5 },
    //   { timeUnit: "year", count: 10 },
    //   { timeUnit: "year", count: 50 },
    //   { timeUnit: "year", count: 100 },
    //   { timeUnit: "year", count: 200 },
    //   { timeUnit: "year", count: 500 },
    //   { timeUnit: "year", count: 1000 },
    //   { timeUnit: "year", count: 2000 },
    //   { timeUnit: "year", count: 5000 },
    //   { timeUnit: "year", count: 10000 },
    //   { timeUnit: "year", count: 100000 }
    //
    // ]);

    // dateAxis.dateFormatter._dictionary.day = "dd MMM YYYY"
    this.dateAxis.renderer.minGridDistance = 80;
    this.dateAxis.renderer.grid.template.location = 0.5;
    this.dateAxis.startLocation = 0.45;
    this.dateAxis.endLocation = 0.55;
    //SKIP FIELD DATA
    chart.tooltip.pointerOrientation = "horizontal";

    this.valueAxis = chart.yAxes.push(new am4charts.ValueAxis());


    chart.cursor = new am4charts.XYCursor();
    chart.plotContainer.tooltipPosition = "pointer"
    chart.plotContainer.tooltipText = ".";
    chart.plotContainer.tooltip["getFillFromObject"] = false;
    chart.plotContainer.tooltip.background.fill = am4core.color("rgba(255,255,255,1)");
    chart.plotContainer.tooltip.background.fillOpacity = 1;
    chart.plotContainer.tooltip.label.fontSize = 13;

    chart.preloader.disabled = true;
    this.getTolltipe();

    // let vm=this
    //  chart.events.on("ready", function() {
    //    vm.valueAxis.min = vm.valueAxis.minZoomed;
    //    vm.valueAxis.max = vm.valueAxis.maxZoomed;
    //  });

//     var chart = am4core.create("chartdiv", am4charts.XYChart);
//
// // Add data
//     chart.data =[
//       {
//         "date": "2022-01-17T00:00:00.000Z",
//         "valueInQueue": 32423,
//         "valueInQueueYesterday": 0,
//         "showTooltip": "",
//         "additional": 32423,
//         "additional1": 10
//       },
//       {
//         "date": "2022-01-19T00:00:00.000Z",
//         "valueInQueue": 121,
//         "valueInQueueYesterday": 32423,
//         "showTooltip": "",
//         "additional": 10,
//         "additional1": 10
//       },
//       {
//         "date": "2022-02-15T00:00:00.000Z",
//         "valueInQueue": 23,
//         "valueInQueueYesterday": 121,
//         "showTooltip": "",
//         "additional": 10,
//         "additional1": 10
//       },
//       {
//         "date": "2022-02-20T00:00:00.000Z",
//         "valueInQueue": 2543,
//         "valueInQueueYesterday": 23,
//         "showTooltip": "",
//         "additional": 10,
//         "additional1": 10
//       },
//       {
//         "date": "2022-04-20T00:00:00.000Z",
//         "valueInQueue": 6,
//         "valueInQueueYesterday": 2543,
//         "showTooltip": "",
//         "additional": 32423,
//         "additional1": 10
//       }
//     ]
//
// // Create axes
//     var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
//     dateAxis.renderer.grid.template.location = 0;
//     dateAxis.renderer.minGridDistance = 30;
//     dateAxis.skipEmptyPeriods = true;
//
//     dateAxis.dateFormats.setKey("day", "dd");
//     dateAxis.dateFormats.setKey("month", "MMM");
//     dateAxis.dateFormats.setKey("year", "YYYY");
//     dateAxis.periodChangeDateFormats.setKey("day", "[bold]MMM[/]");
//     dateAxis.periodChangeDateFormats.setKey("month", "[bold]YYYY[/]");
//
//     dateAxis.gridIntervals.setAll([
//       { timeUnit: "day", count: 1 },
//       { timeUnit: "day", count: 2 },
//       { timeUnit: "day", count: 3 },
//       { timeUnit: "day", count: 4 },
//       { timeUnit: "day", count: 5 },
//       { timeUnit: "month", count: 1 },
//       { timeUnit: "month", count: 3 },
//       { timeUnit: "month", count: 6 },
//       { timeUnit: "month", count: 12 },
//       { timeUnit: "year", count: 1 },
//       { timeUnit: "year", count: 2 },
//       { timeUnit: "year", count: 5 },
//       { timeUnit: "year", count: 10 },
//       { timeUnit: "year", count: 50 },
//       { timeUnit: "year", count: 100 },
//       { timeUnit: "year", count: 200 },
//       { timeUnit: "year", count: 500 },
//       { timeUnit: "year", count: 1000 },
//       { timeUnit: "year", count: 2000 },
//       { timeUnit: "year", count: 5000 },
//       { timeUnit: "year", count: 10000 },
//       { timeUnit: "year", count: 100000 }
//
//     ]);
//
//     // dateAxis.dateFormatter._dictionary.day = "dd MMM YYYY"
//     dateAxis.renderer.minGridDistance = 80;
//     dateAxis.renderer.grid.template.location = 0.5;
//     dateAxis.startLocation = 0.45;
//     dateAxis.endLocation = 0.55;
//
//    chart.yAxes.push(new am4charts.ValueAxis());
//
// Create series
//     function createSeries(field, name) {
//       var series = chart.series.push(new am4charts.LineSeries());
//       series.dataFields.valueY = field;
//       series.dataFields.dateX = "date";
//       series.name = name;
//       series.tooltipText = "{dateX}: [b]{valueY}[/]";
//       series.strokeWidth = 2;
//
//       series.smoothing = "monotoneX";
//
//       var bullet = series.bullets.push(new am4charts.CircleBullet());
//       bullet.circle.stroke = am4core.color("#fff");
//       bullet.circle.strokeWidth = 2;
//
//       return series;
//     }
//
//     createSeries("valueInQueue", "Series #1");
//
//
//     chart.legend = new am4charts.Legend();
//     chart.cursor = new am4charts.XYCursor();
//
// // for(let i=0; i<chart.data.length; i++) {
// //         this.chart.data[i].date = new Date(this.chart.data[i].date)
// //       }
//     chart.cursor = new am4charts.XYCursor();
//     chart.plotContainer.tooltipPosition = "pointer"
//     chart.plotContainer.tooltipText = ".";
//     chart.plotContainer.tooltip["getFillFromObject"] = false;
//     chart.plotContainer.tooltip.background.fill = am4core.color("rgba(255,255,255,1)");
//     chart.plotContainer.tooltip.background.fillOpacity = 1;
//     chart.plotContainer.tooltip.label.fontSize = 13;

  }
}
</script>

<style scoped lang="scss">
@import "lineChart";
</style>